export const DIGEST_RULES_VERSION = "digest-rules@0.1.0";

export const DIGEST_OBSERVATION_DAYS = 14;
export const DIGEST_BASE_PERIOD_DAYS = 7;
export const DIGEST_PERIOD_CANDIDATES = [7, 14, 30] as const;
export const DIGEST_SPARSE_NET_UNITS = 3;
export const DIGEST_SKU_CONCURRENCY = 3;
export const DIGEST_SHORT_HISTORY_DAYS = 30;
export const DIGEST_CRITICAL_CONFIDENCE_MIN = 0.5;
export const DIGEST_MAX_OBSERVATION_DAYS = 90;

export const DIGEST_RUN_STAGES = [
  { id: "scope", label: "Отбор SKU" },
  { id: "sources", label: "Источники данных" },
  { id: "sku", label: "Анализ SKU" },
  { id: "events", label: "События" },
  { id: "narrative", label: "Резюме" },
] as const;

export type DigestRunStageId = (typeof DIGEST_RUN_STAGES)[number]["id"];
